
export default {
  props: {
    items: Array
  }
}
